export enum COLLECTIONS_PERMISSIONS {
  COLLECTIONS_VIEW = 'CONTENT_COLLECTIONSVIEW',
  COLLECTIONS_WRITE = 'CONTENT_COLLECTIONSWRITE',
}
